import Box from '@mui/material/Box';
import EditRoundedIcon from '@mui/icons-material/EditRounded';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import { useState } from 'react';
import { AddColourPalettesModal } from './AddColourPalettesModal';
import { DeleteColourPalettesModal } from './DeleteColourPalettesModal';

export const EditColourPalettesMenu = ({ setColourPalettes }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const closeEditMenu = () => {
        setAnchorEl(null);
    };

    const [openAddModal, setOpenAddModal] = useState(false);
    const handleOpenAddModal = () => {
        closeEditMenu();
        setOpenAddModal(true);
    };

    const [openDeleteModal, setOpenDeleteModal] = useState(false);
    const handleOpenDeleteModal = () => {
        closeEditMenu();
        setOpenDeleteModal(true);
    };

    return (
        <>
            <Box sx={{ display: 'flex', alignItems: 'center', textAlign: 'center' }}>
                <Tooltip title="Edit Colour Palettes">
                    <IconButton
                        onClick={event => {
                            setAnchorEl(event.currentTarget);
                        }}
                        size="small"
                        sx={{ ml: 2 }}
                        aria-controls={open ? 'edit-colour-palettes-menu' : undefined}
                        aria-haspopup="true"
                        aria-expanded={open ? 'true' : undefined}
                        data-testid={'edit-colour-palettes'}
                    >
                        <EditRoundedIcon />
                    </IconButton>
                </Tooltip>
            </Box>

            <Menu
                anchorEl={anchorEl}
                id="edit-colour-palettes-menu"
                open={open}
                onClose={closeEditMenu}
                onClick={closeEditMenu}
                transformOrigin={{ horizontal: 'left', vertical: 'top' }}
                anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}
            >
                <MenuItem onClick={handleOpenAddModal}>Add Colour Palettes</MenuItem>
                <Divider />
                <MenuItem onClick={handleOpenDeleteModal}>Delete Colour Palettes</MenuItem>
            </Menu>

            {openAddModal && <AddColourPalettesModal isOpen={openAddModal} setIsOpen={setOpenAddModal} />}
            {openDeleteModal && (
                <DeleteColourPalettesModal
                    isOpen={openDeleteModal}
                    setIsOpen={setOpenDeleteModal}
                    setColourPalettes={setColourPalettes}
                />
            )}
        </>
    );
};
